import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const updateCustomReservedInventoryBucketType = {
  name: "updateCustomReservedInventoryBucketType" as const,
  input: z.object({
    id: customReservedInventoryBucketTypeIdFormat.schema,
    name: z.string().min(1),
  }),
  output: z.object({ success: z.boolean() }),
};
